module.exports = __webpack_public_path__ + "static/img/df98f51.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/lhsx/5-1.png
// module id = 644
// module chunks = 2